import { recursionCopy } from '@/views/customer/roleManage/utils';
import { addQrConfig, editQrConfig, delQrConfig } from './../request';
import preview from '@/views/insurance/releaseManage/previewFrom/preview.vue';
export default {
  components: {
    preview
  },
  props: ['num', 'dataFrom2', 'isEdit', 'templateGroupList', 'customerInsuranceId', 'insuranceId'],
  data() {
    return {
      isClick: false,
      dataFrom: null
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('模版名称')
        }],
        domain: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('域名')
        }],
        address: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('前端地址')
        }],
        insureLink: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('投保链接')
        }],
        linkType: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('链接类型')
        }],
        templateControlsGroupId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('页面模版')
        }]
      };
    }
  },
  watch: {
    dataFrom2(newVal, oldVal) {
      console.log(889625, newVal, oldVal);
    },
    isEdit() {
      console.log(this.isEdit);
      this.dataFrom.isEdit = this.isEdit;
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.dataFrom2.id != -1) {
        this.infoFun();
      } else {
        this.dataFrom = recursionCopy(this.dataFrom2);
      }
    });
  },
  methods: {
    infoFun() {
      this.dataFrom = recursionCopy(this.dataFrom2);
      if (this.dataFrom.templateControlsGroupId == 0) {
        this.dataFrom.templateControlsGroupId = undefined;
      }
      this.processingFun();
    },
    linkTypeChange() {
      this.isClick = false;
      this.dataFrom = {
        id: this.dataFrom.id,
        name: this.dataFrom.name,
        linkType: this.dataFrom.linkType,
        isEdit: this.dataFrom.isEdit,
        customerInsuranceId: this.dataFrom.customerInsuranceId
        //   insureLink: '',
        //   domain:'',
        //   address: '',
        //   appId: '',
        //   templateControlsGroupId: undefined
      };
    },
    processingFun() {
      if (this.dataFrom2.id == -1) {
        return false;
      }
    },
    onEdit() {
      this.$emit('editOk', this.num);
    },
    onSubmit() {
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          let parameter = recursionCopy(this.dataFrom);
          delete parameter.isEdit;
          if (parameter.id == -1) {
            delete parameter.id;
          }
          if (parameter.linkType == 'NEW_LINK') {
            delete parameter.insureLink;
          } else if (parameter.linkType == 'COMPLETE') {
            delete parameter.domain;
            delete parameter.address;
            delete parameter.appId;
            delete parameter.templateControlsGroupId;
          }
          const FUN = parameter.id ? editQrConfig : addQrConfig;
          const res = await FUN(parameter);
          this.dataFrom.isEdit = false;
          this.$message.success(this.$t('操作成功') + '!');
          this.$emit('ok', res);
        }
      });
    },
    // linkTypeChange (val) {
    //   // this.$refs['dataFrom'].resetFields();
    //   // console.log(val);
    //   // this.dataFrom.linkType = val;
    // },
    onDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该二维码配置') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delQrConfig({
          qrConfigId: this.dataFrom.id
        }).then(res => {
          _this.$message.success(_this.$t('操作成功') + '!');
          this.$emit('ok', res);
        });
      });
    }
  }
};